{
    "Profile_Dwellings_ScheduledItem.scheduledItem": "Scheduled Item",
    "Profile_Dwellings_ScheduledItem.scheduledItemDetails": "Scheduled Item Details",
    "Profile_Dwellings_ScheduledItem.type": "Type",
    "Profile_Dwellings_ScheduledItem.insuredValue": "Insured Value"
}
